// src/integrations/kempower/manifest.js
import logo from './logo.svg'; // Use as image URL React component

const kempowerManifest = {
  slug: 'kempower_chargeye', // must match backend slug and INTEGRATION_MANIFESTS key
  type: 'Integrations::KempowerChargEyeIntegration', // must match backend type
  displayName: 'Kempower ChargEye',
  asset_sync_message: 'Use charger ID (eg: CSXXXXXXX) to add a charger from ChargEye to assign a task to it ',
  logo, // Use as <img src={logo} />ents
  colorClass: 'bg-white',
};

export default kempowerManifest;